import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { Content } from "./Content";

export function ContentRoute({
  children,
  component,
  docTitle = "Winnow",
  pageTitle = "",
  render,
  path,
  ...props
}) {
  const { REACT_APP_APP_ENV } = process.env;

  useEffect(() => {
    let envFancy = "Winnow";

    switch (REACT_APP_APP_ENV) {
      case "prod":
        break;
      case "stag":
        envFancy = "[S]";
        break;
      case "dev":
        envFancy = "D🤓>";
        break;
      default:
        envFancy = "L🐸>";
    }

    if (pageTitle) {
      document.title = `${envFancy}  ${docTitle || "Winnow"} | ${pageTitle}`;
    }
  }, [path, docTitle]);

  return (
    <Route {...props}>
      {(routeProps) => {
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
